<template>
  <div class="turntable-container bg-[#004542]">
    <!-- 吸顶导航栏 -->
    <van-nav-bar :title="navTitle" left-arrow class="custom-nav-bar nav-bar-fixed sticky-nav" :border="false">
      <template #left>
        <Button type="back" @click="onClickLeft" />
      </template>
    </van-nav-bar>
    <!-- 内容区域 -->
    <div class="content-container">
      <div class="mx[19px] my-[30px]">
        <div class="flex items-center justify-between mx-[15px]">
          <div class="w-1/5">
            <img :src="getAssetsFile('activity/dazhuanpan/cash_dollar.png')" alt="" class="w-[40px] h-[27px]">
          </div>
          <div class="w-3/5 flex items-center justify-center color-[#FFCF42] text-[23px] font-bold text-line-1-#002421">
            <div class="w-[40px]">{{ VITE_symbol }}</div>
            <div class="text-left">{{ numberFormat(animatedValue, { minDecimals: 2 }) }}</div>
          </div>
          <div class="w-1/5 ">
            <div class="saquestyle" @click="showSaquePopup = true">

            </div>
            <!-- <img :src="getAssetsFile('activity/dazhuanpan/coin.webp')" alt="" class="w-[14px] h-[14px] "
              style="object-fit: contain;"> -->
            <!-- <div class="ml-[4px]">{{ t('turntable.withdraw') }}</div> -->
          </div>
        </div>
        <div class="mt-[5px] mx-[15px]">
          <div class="flex  justify-between">
            <div></div>
            <div class="color-[#fff] text-[12px] font-bold">{{ numberFormat(animatedProgress, { minDecimals: 2 }) }}%
            </div>
          </div>
          <div class="prossess">

            <div class="h-full rounded-full bg-[#009fce] prossess-in flex justify-end"
              :style="{ width: `${animatedProgress}%` }">
              <div class="prossess-item"></div>
            </div>
          </div>
        </div>
        <div class="text-[12px] font-[500] color-[#FFF] w-full text-center mt-[10px]">
          {{ t('turntable.needMore') }} <span class="color-[#7EE142]">{{ numberFormat(animatedValue2, {
            minDecimals: 2
          }) }}</span> {{ t('turntable.toWithdraw') }}
        </div>
      </div>
      <!-- 修改转盘容器，添加溢出控制 -->
      <div class="flex flex-col w-full relative h-[540px] dwjers">
        <!-- 头部背景 -->
        <div
          class="headerTitleBoxContainer box-border w-[calc(100vw-30px)] h-[106px] absolute top-[76px] left-[15px] z-10">
          <div class="relative w-full h-full headerTitleBox p-[2px]">
            <div class="absolute left-[6px] top-[10px]">
              <img :src="getAssetsFile('activity/dazhuanpan/luckyWheel.png')" alt="" srcset=""
                class="w-[187px] h-[42px]">
            </div>
            <div class="absolute right-[1.5%] top-[2px]">
              <img :src="getAssetsFile('activity/dazhuanpan/beauty.png')" alt="" srcset="" class="w-[133px] h-[102px]">
            </div>
            <div
              class="absolute w-[120px] left-[6px] bottom-[10px] text-[13px] text-white text-stroke-sm text-stroke-[#103D7F]">
              <div>{{ t('turntable.freeSpin') }} </div>
              <div>{{ t('turntable.whenYouSpend') }}</div>
            </div>
          </div>
        </div>
        <!-- 底层光圈 - 保持自动缓慢旋转 -->
        <!-- <img :src="getAssetsFile('activity/dazhuanpan/share_aperture.webp')" alt=""
          class="rotating-image absolute w-[80%] h-auto top-23 left-[6%] z-10" style="object-fit: contain;"> -->

        <!-- 转盘外部框 -->
        <img :src="getAssetsFile('activity/dazhuanpan/share_bg_BR.png')" alt=""
          class="absolute w-[82%] h-auto top-5.2/9 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-15"
          style="object-fit: contain;">

        <!-- 转盘边框灯光 - 突然切换闪烁效果 -->
        <!-- <img :src="getAssetsFile('activity/dazhuanpan/share_light.webp')" alt=""
          class="light-switch absolute w-[58%] h-[70%] top-[55%] left-[50%] transform -translate-x-1/2 -translate-y-1/2 z-20"
          style="object-fit: contain; pointer-events: none;"> -->

        <!-- 转盘和奖品容器 - 一起旋转 -->
        <div
          class=" turntable-container absolute w-[72%] h-[56.6%] top-[29.4%] left-[14%] transform -translate-x-1/2 -translate-y-1/2 z-30"
          :class="{ 'spinning': isSpinning }" :style="{ transform: `rotate(${spinAngle}deg)` }">
          <!-- 内部转盘背景 -->
          <img :src="getAssetsFile('activity/dazhuanpan/share_spin.png')" alt="" class="w-full h-full"
            style="object-fit: contain;">

          <!-- 奖品容器 - 现在在转盘内部 -->
          <div class="absolute w-full h-full top-0 left-0">
            <div v-for="(prize, index) in turntablePrizes" :key="index" class="turntable-prize"
              :class="`prize-${index}`">
              <!-- 奖品内容 -->
              <div :class="`prize-content-${index}`">
                <!-- 金额类型 -->
                <div v-if="prize.type === 'money'" :class="[`money-color-${index}`, {
                  'text-line-0.5-#002421': index % 2 === 0,
                  'text-line-0.5-#FFFFFF': index % 2 === 1,
                }]">
                  {{ numberFormat(parseFloat(prize.value), { minDecimals: 2 }) }}
                </div>
                <!-- 图片类型 -->
                <img v-else-if="prize.type === 'image' && prize.image" :src="prize.image" alt="" class="prize-image" />
              </div>
            </div>
          </div>
        </div>

        <!-- 转盘角标 -->
        <img :src="getAssetsFile('activity/dazhuanpan/pointer.png')" alt=""
          class="absolute w-[15%] h-[40%] top-[31.5%] left-[49%] transform -translate-x-1/2 -translate-y-1/2 z-40"
          style="object-fit: contain; pointer-events: none;">

        <!-- 抽奖按钮 - 添加点击事件 -->
        <div class="
          absolute
          top-[53%]
          left-[50%]
          transform
          -translate-x-1/2
          -translate-y-1/2
          mt-[25px]
          z-30
          flex
          items-center
          justify-center
          w-[28%]
          h-[28%]
          cursor-pointer
          z-20
          " @click="startSpin" :class="{ 'pointer-events-none': isSpinning }">
          <img :src="getAssetsFile('activity/dazhuanpan/share_start.png')" alt="" class="w-full h-full absolute"
            style="object-fit: contain;">
          <!-- <div class="text-white font-bold z-40 relative pt-[2px] whitespace-nowrap"
            :class="showPrizeAmount ? 'text-[12px]' : 'text-[25px]'">
            {{ showPrizeAmount ? currentPrizeAmount : turntableCount }}
          </div> -->
        </div>
        <!-- 抽奖座圈 -->
        <img :src="getAssetsFile('activity/dazhuanpan/share_ring.png')" alt=""
          class="absolute w-[80%] h-auto top-[83.5%] left-[10%] transform  z-2" style="object-fit: contain;">

        <!-- SPIN -->
        <img :src="getAssetsFile('activity/dazhuanpan/spin.png')" alt=""
          class="absolute w-[50%] h-auto top-[77.8%] left-[48%] transform  -translate-x-1/2 z-2"
          style="object-fit: contain;">
      </div>
    </div>

    <div class="bg-gradient-to-b from-[#002d27] to-[#00433f] !after:hidden">
      <div class="w-full flex justify-center flex-col items-center">
        <div class="flex justify-center items-center h-[36px]">
          <div class="color-[#FFFFFF] text-[12px]">{{ t('turntable.expirationTime') }}</div>
          <div class="color-[#FFCF42] text-[12px] ml-[5px]">{{ countDownTime }}</div>
        </div>
        <div class="bojksee mt-[15px] text-[13px] text-white flex">
          <div class="w-8/10 pr-[10px] flex justify-end items-center">{{ t('turntable.inviteFriendsToHelp') }}</div>
          <div class="w-2/10 relative">
            <img :src="getAssetsFile('activity/dazhuanpan/share2.png')" alt=""
              class="w-[40px] h-[40px] absolute right-3 -top-[6px] cursor-pointer" style="object-fit: contain;"
              @click="showSharePopup = true">
          </div>

        </div>
        <div class="teabser">
          <div :class="['cursor-pointer', { 'active-tab': activeTab === 'relatorio' }]"
            @click="handleTabClick('relatorio')">
            {{ t('turntable.report') }}</div>
          <div :class="['cursor-pointer', { 'active-tab': activeTab === 'referencia' }]"
            @click="handleTabClick('referencia')">{{ t('turntable.myReference') }}</div>
        </div>
        <!-- 滚动内容区域 -->
        <div class=" tabdatastyle">
          <div class="scroll-container" :class="{ 'manual-scroll': activeTab === 'referencia' }">
            <!-- Relatorio（假数据，字段：id、action、amount） -->
            <div v-if="activeTab === 'relatorio'" class="scroll-content"
              :style="{ transform: `translateY(${scrollOffset}px)` }">
              <div v-for="(item, index) in displayList" :key="index" class="flex items-center mb-[10px]">
                <div class="text-[#18C2B3] text-[12px]">{{ maskId(item.id) }}</div>
                <div class="ml-[70px] text-[#18C2B3] text-[12px]">{{ item.action }}</div>
                <div class="flex items-center">
                  <div class="color-[#FFCF42] text-[11px] font-[500] ml-[30px]">+ {{ numberFormat(item.amount) }}
                  </div>
                  <div class="w-[15px] h-[15px] ml-[5px] text-[#18C2B3] text-[12px]">{{ VITE_symbol }}</div>
                  <!-- <img :src="getAssetsFile('activity/dazhuanpan/qianmoney.png')" alt="" class="w-[15px] h-[15px] ml-[5px]" style="object-fit: contain;"> -->
                </div>
              </div>
            </div>
            <!-- Minha Referencia（接口数据，字段：userId、amount、time） -->
            <div v-else class="scroll-content">
              <div v-for="(item, index) in referenciaRawList" :key="index"
                class="flex items-center mb-[10px] justify-between">
                <div class="flex-1 text-center text-[11px] color-[#aaa]">{{ formatTime(item.time, 'YYYY/MM/DD HH:mm')
                }}</div>
                <div class="flex-1 text-center ml-[20px]">{{ t('turntable.justWithdrew') }}</div>
                <div class="flex-1 text-center color-[#72D242]"> +{{ numberFormat(item.amount) }} {{ VITE_symbol }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="textstyles">
          <div>{{ t('turntable.eventDetails') }}: </div>
          <div class="text-[12px] mt-[5px] mb-[13px] line-height-[16px]">{{ t('turntable.rule1') }}</div>
          <div class="text-[12px]  mb-[13px] line-height-[16px]">{{ t('turntable.rule2') }}</div>
          <div class="text-[12px]  mb-[13px] line-height-[16px]">{{ t('turntable.rule3') }}</div>
          <div class="text-[12px]  mb-[13px] line-height-[16px]">{{ t('turntable.rule4') }}</div>
          <div class="text-[12px]  mb-[13px] line-height-[16px]">{{ t('turntable.rule5') }}</div>
        </div>
      </div>
      <div class="h-[50px]"></div>
    </div>

  </div>
  <!-- 分享弹窗 -->
  <van-popup v-model:show="showSharePopup" position="bottom"
    :style="{ height: 'auto', maxHeight: '80vh', borderRadius: '0 0 0 0' }" round close-icon-position="top-right">
    <div class="mt-[14px] mx-[12px]">
      <div class="flex justify-between">
        <div class="dogtitle    " style="">1. {{ t('turntable.inviteFriendsToHelp') }}</div>
        <img :src="getAssetsFile('activity/dazhuanpan/close.png')" alt="" class="w-[11px] h-[11px]"
          @click="showSharePopup = false">
      </div>
      <div id="my-inline-buttons" style="z-index:999;margin-top:50px;margin-bottom: 30px;"></div>


      <!-- 链接复制区域 -->
      <div class="bg-[#F6F6F6] p-1 rounded-lg mb-4 mt-[20px]" style="padding-top:2px;padding-bottom:2px;">
        <div class="flex items-center">
          <div class="flex-1 p-2 border rounded-l color-[#8989A5] text-[13px]">
            {{ shareLink }}
          </div>
          <div @click="copyLink" class="text-white px-4 py-2 color-[#40A4E4] text-[13px]">
            Copiar
          </div>
        </div>
      </div>

      <div class="dogtitle mb-[10px]">{{ t('turntable.sendInviteToRandom') }}</div>
      <div class="grid  mb-6 bg-[#898988] rounded-[3px]">
        <!-- 随机用户列表 -->
        <div class=" flex  flex-wrap justify-center justify-between px-[10px] py-[5px]">
          <div v-for="user in randomUsers" :key="user.phone" class=" p1 rounded text-center cursor-pointer text-[11px]"
            :class="user.has ? 'color-[#666]' : 'color-[#fff]'" @click="selectUser(user)">
            {{ user.phone }}
          </div>
        </div>
        <!-- 发送按钮 -->
        <div class="flex gap-4 mb-[10px] mx-[10px]">
          <div @click="sendWhatsAppMessage"
            class="flex-1  bg-[#FFF] color-[#000] py-[7px]  text-[11px]  rounded-[4px]  px-[10px] flex  items-center justify-between">
            <div>
              <div>{{ t('turntable.sendMessage') }}</div>
              <div class=" mt-[5px]" style="font-weight: 900;">WhatsAPP</div>
            </div>
            <img :src="getAssetsFile('activity/dazhuanpan/call.svg')" alt="" class="w-[37px] h-[37px]">
          </div>
          <div @click="sendSMSMessage"
            class="flex-1  bg-[#FFF] color-[#000]  text-[11px]  px-[10px]  py-[7px] rounded-[4px] flex  items-center ">
            <img :src="getAssetsFile('activity/dazhuanpan/sms.png')" alt="" class="w-[37px] h-[37px]">
            <div class="ml-[10px]">
              <div>{{ t('turntable.sendMessage') }}</div>
              <div class=" mt-[5px]" style="font-weight: 900;">SMS</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </van-popup>

  <!-- SAQUE弹窗 -->
  <van-popup v-model:show="showSaquePopup" position="center" class="saque-popup" :style="{
    width: '85%',
    borderRadius: '35px',
    backgroundColor: '#004D37',
    height: 'auto',
    maxHeight: '80vh'
  }" close-icon-position="top-right" close-icon-color="#fff" @close="handleSaquePopupClose">
    <div class="saque-popup-content">
      <!-- 标题 -->
      <div class="saque-title">
        <span class="text-[13px]">{{ t('turntable.youWillReceiveSoon') }}</span>
        <img :src="getAssetsFile('activity/dazhuanpan/close2.png')" alt="" class="w-[17px] h-[17px]"
          @click="showSaquePopup = false">
      </div>
      <div class="bg-[#00563A] rounded-[10px]" style="overflow: hidden;">
        <!-- 余额信息 -->
        <div class="balance-section">
          <div class="balance-label">{{ t('turntable.yourCurrentBalance') }}</div>
          <div class="balance-amount">
            <span class="balance-value">{{ numberFormat(animatedValue, { minDecimals: 2 }) }}</span>
            <span class="balance-currency">{{ VITE_symbol }}</span>
          </div>
        </div>

        <!-- 空白的Número de Iniciações -->
        <div class="initiation-section">
          <div class="initiation-label">{{ t('turntable.numberOfInitiations') }}</div>
        </div>

        <!-- 支付方式步骤 -->
        <div class="payment-section">
          <div class="payment-label">{{ t('turntable.paymentMethod') }}</div>
          <div class="payment-steps">
            <div class="step-item">
              <img :src="getAssetsFile('activity/dazhuanpan/gouzhong.png')" alt="" class="w-[15px] h-[15px]">
              <!-- <div class="step-icon">
                                                <van-icon name="success" color="#fff" size="12" />
                                            </div> -->
              <div class="step-text">{{ t('turntable.paymentRequestSent') }}</div>
            </div>
            <div class="step-item">
              <img :src="getAssetsFile('activity/dazhuanpan/gouzhong.png')" alt="" class="w-[15px] h-[15px]">
              <div class="step-text">{{ t('turntable.stillShortBy') }} {{ numberFormat(animatedValue2, {
                minDecimals: 2
              }) }} {{ t('turntable.youCanRequestWithdrawalNow') }}</div>
            </div>
            <div class="step-item">
              <img v-if="animatedValue >= withdrawAmount" :src="getAssetsFile('activity/dazhuanpan/gouzhong.png')"
                alt="" class="w-[15px] h-[15px]">
              <div v-if="animatedValue < withdrawAmount" class="step-dotder">
              </div>
              <div class="step-text" :class="{ 'text-green': animatedValue >= withdrawAmount }">
                {{ numberFormat(withdrawAmount, { minDecimals: 2 }) }} {{ VITE_symbol }} {{
                  t('turntable.willBeDepositedIntoYourAccount') }}
              </div>
            </div>
          </div>
        </div>
      </div>


      <!-- 按钮区域 -->
      <div class="button-section">
        <div class="invite-button" @click="handleInviteClick">
          <span>{{ t('turntable.inviteFriendsToHelp') }}</span>
          <div class="button-shine"></div>
        </div>
      </div>
    </div>
  </van-popup>


  <!-- 添加登录弹窗 -->
  <AuthDialog :show="showAuthDialog" :is-login="authIsLogin" @close="handleAuthDialogClose"
    @switch="handleAuthDialogSwitch" />
</template>
<script setup lang="ts">
import { Button } from "@/components/Button"
import { ref, onMounted, watch, onUnmounted, nextTick, computed, reactive } from 'vue';
import { numberFormat } from '@/utils/formatter';
import { showToast } from 'vant';
import AuthDialog from '@/components/AuthDialog.vue';
import { useActivityStore } from '@/stores/modules/activity';
import { useUserStore } from '@/stores/modules/user'
import * as GameApi from '@/api/game'
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'
import dayjs from 'dayjs' // 添加 dayjs 导入
import { formatTime } from '@/utils/date'
import { getAssetsFile } from '@/utils/pub-use'
const { t } = useI18n()
const route = useRoute()
const onClickLeft = () => history.back();
const VITE_symbol = import.meta.env.VITE_SYMBOL
// 初始化 store
const activityStore = useActivityStore()
const userStore = useUserStore()

// 初始值为0
const prossess = ref(0);
const prossess2 = ref(0); // 添加第二个接口字段
// 动画显示的数值
const animatedValue = ref(0);
const animatedValue2 = ref(0); // 初始值设为0，等待接口数据
// 进度条动画值
const animatedProgress = ref(0);
// 转盘使用次数
const turntableCount = ref(0); // 添加转盘次数变量
// 添加提现金额字段
const withdrawAmount = ref(100); // 默认值，会被接口数据替换
// 能领取的金额（从接口直接获取，不参与计算）
const canWithdrawAmount = ref(0);

// 导航栏标题，包含格式化的数字（显示能领取多少）
const navTitle = computed(() => {
  return `${t('turntable.title', { amount: VITE_symbol + numberFormat(canWithdrawAmount.value, { minDecimals: 2 }) })}`
})

// 添加转盘状态
const isSpinning = ref(false);
const spinAngle = ref(0);

const userInfo = computed(() => userStore.userInfo)
const shareLink = computed(() => `${window.location.origin}?pid=` + userInfo.value?.activeCode)
const shareContent = reactive({
  url: computed(() => shareLink.value), // 使用 computed 包装
  title: `🎉 Join bluewhale and get ${VITE_symbol}1000 bonus! `,
  description: `Enter the welcome gift code: ROMAIN, Each user can receive a bonus of up to ${VITE_symbol}1000 from the gift code. Login link: Referrer's invitation link. Go to [Mine] - [Gift Code] and enter the gift code to claim your reward`
})



// 转盘旋转函数
const startSpin = async () => {
  // 检查是否已登录
  if (!userStore.isLoggedIn || !userStore.userInfo || !userStore.userInfo.userId) {
    // 未登录，显示全局登录弹窗
    const inviteCode = (route.query?.pid as string) || "";
    window.$showLoginDialog(inviteCode);
    return;
  }

  // 如果抽奖次数为0，直接弹出分享弹窗
  if (turntableCount.value <= 0) {
    showSharePopup.value = true;
    return;
  }

  if (isSpinning.value) return;

  // 检查提现状态，如果已经达到提现条件，不允许抽奖
  if (withdrawStatus.value) {
    (window as any).$toast(t('turntable.alreadyReceivedPrize'));
    return;
  }

  // 如果之前有闪光效果，先清除
  clearAllFlashEffects();

  isSpinning.value = true;

  try {
    // 调用抽奖接口
    const response = await GameApi.receiveTheAward();
    console.log('抽奖结果:', response);

    // 获取中奖金额
    const prizeAmount = response.data || 0;
    console.log("开始转圈")
    // 根据中奖金额决定转到哪个奖品
    const prizeIndex = findPrizeIndexByValue(`${VITE_symbol} ${prizeAmount.toFixed(2)}`);

    // 计算目标角度 - 让对应奖品滚动到指针指向的位置（12点钟方向）
    const prizeAngle = prizeIndex * 45; // 奖品当前角度

    // 简化逻辑：总是从当前位置旋转到目标位置
    // 转8圈后，让对应奖品停在12点钟位置（0度）
    const targetRotation = 360 * 8 + (360 - prizeAngle);

    // 转盘旋转动画 - 每次都从0度开始
    const startAngle = 0; // 固定从0度开始
    const endAngle = targetRotation;
    const duration = 6000; // 6秒动画

    const startTime = Date.now();

    const animate = () => {
      const currentTime = Date.now();
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);

      // 使用更自然的缓动函数 - 开始快，结束慢
      const easeOutCubic = 1 - Math.pow(1 - progress, 3);
      spinAngle.value = startAngle + (endAngle - startAngle) * easeOutCubic;

      if (progress < 1) {
        requestAnimationFrame(animate);
      } else {
        // 旋转结束，显示中奖结果
        isSpinning.value = false;
        showPrizeResult(prizeIndex, ` ${VITE_symbol} ${prizeAmount.toFixed(2)}`);

        // 转盘保持在最终位置，不自动重置
        console.log("转圈结束")
        // 抽奖完成后，重新获取抽奖次数
        fetchData().catch(error => {
          console.error('获取抽奖次数失败:', error);
        });
      }
    };

    animate();

  } catch (error) {
    console.error('抽奖失败:', error);
    isSpinning.value = false;
    // 可以显示错误提示
  }
};

// 添加清除所有闪光效果的函数
const clearAllFlashEffects = () => {
  // 移除所有奖品的闪光效果
  for (let i = 0; i < 8; i++) {
    const prizeElement = document.querySelector(`.prize-${i}`);
    if (prizeElement) {
      prizeElement.classList.remove('winner-flash');
    }
  }
};

// 添加重置转盘的函数 - 可以在退出页面时调用
const resetTurntable = () => {
  spinAngle.value = 0;
  clearAllFlashEffects();
};

// 根据奖品数值找到对应的索引 - 修改为根据金额返回不同索引
const findPrizeIndexByValue = (prizeValue: string) => {
  // 解析金额
  const amount = parseFloat(prizeValue.replace(`${VITE_symbol} `, '').replace(',', '.'));

  // 如果金额是0，返回苦脸奖品索引（coins - prize-5）
  if (amount === 0) {
    return 5; // prize-5 是 coins 苦脸奖品
  }

  // 其他情况返回第一个奖品（图片）
  return 0; // prize-0 是 cash_dollar 图片
};

// 模拟抽奖接口
const fetchPrizeResult = async () => {
  // 这里替换为你的实际接口调用
  // const response = await api.spinTurntable();
  // return response.data;

  // 模拟接口返回
  return new Promise((resolve) => {
    setTimeout(() => {
      // 随机返回一个奖品值
      const prizes = ['1.00', '50.00', '100.00'];
      const randomPrize = prizes[Math.floor(Math.random() * prizes.length)];
      resolve({ prizeValue: randomPrize });
    }, 0);
  });
};

// 显示中奖结果
const showPrizeResult = (prizeIndex: number, prizeValue: string) => {
  // 添加中奖区域的闪光效果
  const prizeElement = document.querySelector(`.prize-${prizeIndex}`);
  if (prizeElement) {
    prizeElement.classList.add('winner-flash');
    // 3秒后移除闪光效果
    setTimeout(() => {
      prizeElement.classList.remove('winner-flash');
    }, 3000);
  }


  // 显示中奖金额
  currentPrizeAmount.value = '+' + prizeValue.replace(`${VITE_symbol} `, '');
  showPrizeAmount.value = true;

  // 2秒后显示SAQUE弹窗
  setTimeout(() => {
    showSaquePopup.value = true;
  }, 2000);

  // 更新当前金额（加上中奖金额）
  const currentAmount = parseFloat(prizeValue.replace(`${VITE_symbol} `, '').replace(',', '.'));
  const newTotal = animatedValue.value + currentAmount;

  // 触发金额动画更新
  animateNumber(animatedValue.value, newTotal, 1000);

  // 同时更新剩余金额
  const newRemaining = Math.max(0, withdrawAmount.value - newTotal);
  animateNumber2(animatedValue2.value, newRemaining, 1000);
};


// 数字动画函数
const animateNumber = (startValue: number, endValue: number, duration: number = 2000) => {
  const startTime = Date.now();
  const difference = endValue - startValue;

  const animate = () => {
    const currentTime = Date.now();
    const elapsed = currentTime - startTime;
    const progress = Math.min(elapsed / duration, 1);

    // 使用缓动函数让动画更自然
    const easeOutQuart = 1 - Math.pow(1 - progress, 4);
    const currentValue = startValue + (difference * easeOutQuart);
    // 保留两位小数
    animatedValue.value = Number(currentValue.toFixed(2));

    // 同时更新进度条位置（根据withdrawAmount计算百分比）
    if (withdrawAmount.value > 0) {
      const progressPercent = (currentValue / withdrawAmount.value) * 100;

      // 在动画过程中也要限制圆点位置，不能超出95%
      if (progressPercent >= 100) {
        animatedProgress.value = 98;
      } else {
        // 对于小于100%的情况，也要限制最大值
        const limitedProgress = Math.min(progressPercent, 98);
        animatedProgress.value = Number(limitedProgress.toFixed(2));
      }
    }

    if (progress < 1) {
      requestAnimationFrame(animate);
    } else {
      animatedValue.value = Number(endValue.toFixed(2));
      if (withdrawAmount.value > 0) {
        const finalProgressPercent = (endValue / withdrawAmount.value) * 100;
        if (finalProgressPercent >= 100) {
          animatedProgress.value = 98;
        } else {
          const finalLimitedProgress = Math.min(finalProgressPercent, 98);
          animatedProgress.value = Number(finalLimitedProgress.toFixed(2));
        }
      }
    }
  };

  animate();
};

// 第二个数字的倒数动画函数
const animateNumber2 = (startValue: number, endValue: number, duration: number = 2000) => {
  const startTime = Date.now();
  const difference = endValue - startValue; // 这里会是负数，因为是从withdrawAmount倒数

  const animate = () => {
    const currentTime = Date.now();
    const elapsed = currentTime - startTime;
    const progress = Math.min(elapsed / duration, 1);

    // 使用缓动函数让动画更自然
    const easeOutQuart = 1 - Math.pow(1 - progress, 4);
    const currentValue = startValue + (difference * easeOutQuart);
    // 保留两位小数
    animatedValue2.value = Number(currentValue.toFixed(2));

    if (progress < 1) {
      requestAnimationFrame(animate);
    } else {
      animatedValue2.value = Number(endValue.toFixed(2));
    }
  };

  animate();
};
const cash_dollar = getAssetsFile('activity/dazhuanpan/cash_dollar.png')
const cash_dollar_2 = getAssetsFile('activity/dazhuanpan/piece_rangeAmount.png')
const coins = getAssetsFile('activity/dazhuanpan/kunian.png')
const money_stack = getAssetsFile('activity/dazhuanpan/jingbisns.png')
const turntablePrizes = ref([]);
// 添加倒计时相关变量
const countDownTime = ref('2DAY18:21:53'); // 默认值
const countDownSeconds = ref(0); // 倒计时秒数
let countDownTimer: NodeJS.Timeout | null = null; // 倒计时定时器

// 添加提现状态字段
const withdrawStatus = ref(false);

// 缓存相关函数
const getTurntableCacheKey = () => {
  const userId = userStore.userInfo?.userId || 'anonymous';
  return `turntable_data_cache_${userId}`;
};
const CACHE_EXPIRE_TIME = 5 * 60 * 1000; // 5分钟缓存过期

// 获取缓存的转盘数据
const getCachedTurntableData = () => {
  try {
    const cacheKey = getTurntableCacheKey();
    const cached = localStorage.getItem(cacheKey);
    if (cached) {
      const data = JSON.parse(cached);
      // 检查缓存是否过期
      if (Date.now() - data.timestamp < CACHE_EXPIRE_TIME) {
        return data.data;
      } else {
        // 缓存过期，清除
        localStorage.removeItem(cacheKey);
      }
    }
  } catch (error) {
    console.error('读取转盘缓存数据失败:', error);
  }
  return null;
};

// 保存转盘数据到缓存
const saveTurntableDataToCache = (data: any) => {
  try {
    const cacheKey = getTurntableCacheKey();
    const cacheData = {
      data: data,
      timestamp: Date.now()
    };
    localStorage.setItem(cacheKey, JSON.stringify(cacheData));
    console.log('转盘数据已保存到缓存');
  } catch (error) {
    console.error('保存转盘缓存数据失败:', error);
  }
};

// 应用转盘数据到页面
const applyTurntableData = (data: any) => {
  if (!data) return;

  // 设置提现金额（需要达到的金额）
  withdrawAmount.value = data.withdrawAmount || 100;
  // 设置能领取的金额（从接口直接获取）
  canWithdrawAmount.value = data.withdrawAmount || 0;

  // 设置当前进度值 - 使用 haveAmount
  const haveAmount = data.haveAmount || 0;
  prossess.value = haveAmount;
  // 立即更新动画值，避免显示旧数据
  animatedValue.value = haveAmount;

  // 设置还需要多少金额 - 计算剩余金额
  const remaining = (data.withdrawAmount || 100) - haveAmount;
  prossess2.value = Math.max(0, remaining);
  // 立即更新动画值，避免显示旧数据
  animatedValue2.value = Math.max(0, remaining);

  // 更新进度条
  const progressPercent = haveAmount > 0 && withdrawAmount.value > 0
    ? Math.min((haveAmount / withdrawAmount.value) * 100, 98)
    : 0;
  animatedProgress.value = progressPercent;

  // 设置转盘次数 - 使用 raffleCount
  turntableCount.value = data.raffleCount || 0;

  // 设置提现状态 - 使用 withdrawStatus 字段
  withdrawStatus.value = data.withdrawStatus || false;

  // 设置倒计时 - 使用 countDownTime 字段
  if (data.countDownTime) {
    countDownSeconds.value = data.countDownTime;
    startCountDown();
  }

  // 设置提现记录数据 - 使用 withdrawAmountList 字段
  if (data.withdrawAmountList && Array.isArray(data.withdrawAmountList)) {
    referenciaRawList.value = data.withdrawAmountList.map(item => ({
      userId: item.userId || 'Unknown',
      amount: item.amount || 0,
      time: item.time || ''
    }));
  } else {
    referenciaRawList.value = [];
  }

  // 直接赋值 phone 数组
  if (data.phone && Array.isArray(data.phone)) {
    randomUsers.value = data.phone;
  } else {
    randomUsers.value = [];
  }

  // 处理转盘奖品数据 - 使用 rewardInfo 数组
  const defaultPrizes = [
    { type: 'image', value: null, image: cash_dollar_2 },
    { type: 'money', value: '1.00', image: null },
    { type: 'money', value: '50.00', image: null },
    { type: 'money', value: '30.00', image: null },
    { type: 'image', value: null, image: cash_dollar_2 },
    { type: 'image', value: null, image: coins },
    { type: 'money', value: '100.00', image: null },
    { type: 'image', value: null, image: money_stack },
  ];

  // 如果有 rewardInfo 数据，替换 type 为 2 的金额
  if (data.rewardInfo && Array.isArray(data.rewardInfo)) {
    const rewardInfo = data.rewardInfo;
    const type2Rewards = rewardInfo.filter(item => item.type === 2);

    // 替换对应位置的金额
    if (type2Rewards.length > 0) {
      if (type2Rewards[0]) {
        defaultPrizes[1].value = numberFormat(type2Rewards[0].maxAmount, { minDecimals: 2 });
      }
      if (type2Rewards[1]) {
        defaultPrizes[2].value = numberFormat(type2Rewards[1].maxAmount, { minDecimals: 2 });
      }
      if (type2Rewards[2]) {
        defaultPrizes[3].value = numberFormat(type2Rewards[2].maxAmount, { minDecimals: 2 });
      }
      if (type2Rewards[3]) {
        defaultPrizes[6].value = numberFormat(type2Rewards[3].maxAmount, { minDecimals: 2 });
      }
    }
  }

  turntablePrizes.value = defaultPrizes;
};

// 清除转盘数据缓存
const clearTurntableCache = () => {
  try {
    // 清除当前用户的缓存
    const cacheKey = getTurntableCacheKey();
    localStorage.removeItem(cacheKey);
    // 同时清除所有可能的旧缓存（兼容旧版本）
    const keys = Object.keys(localStorage);
    keys.forEach(key => {
      if (key.startsWith('turntable_data_cache')) {
        localStorage.removeItem(key);
      }
    });
    console.log('转盘缓存已清除');
  } catch (error) {
    console.error('清除转盘缓存失败:', error);
  }
};

// 重置所有转盘数据
const resetTurntableData = () => {
  // 重置所有数据为初始值
  withdrawAmount.value = 100;
  canWithdrawAmount.value = 0; // 重置能领取的金额
  prossess.value = 0;
  prossess2.value = 0;
  animatedValue.value = 0;
  animatedValue2.value = 0;
  animatedProgress.value = 0;
  turntableCount.value = 0;
  countDownSeconds.value = 0;
  withdrawStatus.value = false;
  referenciaRawList.value = [];
  turntablePrizes.value = [];
  randomUsers.value = [];
  // 重置转盘角度
  spinAngle.value = 0;
  // 清除倒计时定时器
  if (countDownTimer) {
    clearInterval(countDownTimer);
    countDownTimer = null;
  }
  console.log('转盘数据已重置');
};

// 修改 fetchData 函数，直接赋值 phone 数据
const fetchData = async () => {
  try {
    console.log('开始获取转盘数据...');

    // 先尝试从本地存储获取缓存数据（只获取当前用户的缓存）
    const cachedData = getCachedTurntableData();
    if (cachedData) {
      console.log('使用缓存的转盘数据:', cachedData);
      applyTurntableData(cachedData);
    }

    // 强制刷新数据，确保获取最新数据
    const data = await activityStore.refreshFinancialData();
    console.log('转盘数据获取成功:', data);

    // 保存数据到本地存储
    if (data) {
      saveTurntableDataToCache(data);
    }

    // 应用接口数据到页面
    if (data) {
      applyTurntableData(data);
      console.log('转盘数据应用完成');
    } else {
      console.warn('获取到的数据为空');
      // 如果接口返回空数据，重置为初始值
      resetTurntableData();
    }
  } catch (error) {
    console.error('获取转盘数据失败:', error);
    // 如果接口失败，重置为初始值
    resetTurntableData();
  }
};

// 转盘抽奖成功后更新数据
const updateDataAfterSpin = (newCount: number, newAmount: number) => {
  activityStore.updateTurntableCount(newCount);
  activityStore.updateHaveAmount(newAmount);

  // 更新本地数据
  turntableCount.value = newCount;
  prossess.value = newAmount;
  const remaining = (withdrawAmount.value || 100) - newAmount;
  prossess2.value = Math.max(0, remaining);
};

// 开始倒计时
const startCountDown = () => {
  // 清除之前的定时器
  if (countDownTimer) {
    clearInterval(countDownTimer);
  }

  // 立即更新一次显示
  updateCountDownDisplay();

  // 设置定时器，每秒更新一次
  countDownTimer = setInterval(() => {
    if (countDownSeconds.value > 0) {
      countDownSeconds.value--;
      updateCountDownDisplay();
    } else {
      // 倒计时结束，清除定时器
      if (countDownTimer) {
        clearInterval(countDownTimer);
        countDownTimer = null;
      }
    }
  }, 1000);
};

// 更新倒计时显示
const updateCountDownDisplay = () => {
  countDownTime.value = formatCountDown(countDownSeconds.value);
};

// 倒计时格式化函数
const formatCountDown = (seconds: number) => {
  const days = Math.floor(seconds / (24 * 60 * 60));
  const hours = Math.floor((seconds % (24 * 60 * 60)) / (60 * 60));
  const minutes = Math.floor((seconds % (60 * 60)) / 60);
  const secs = seconds % 60;

  if (days > 0) {
    return `${days}DAY${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  } else {
    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  }
};

// 监听prossess变化，触发动画
watch(prossess, (newValue) => {
  if (newValue > 0) {
    animateNumber(0, newValue, 4000);
  }
});

// 监听prossess2变化，触发倒数动画
watch(prossess2, (newValue) => {
  if (newValue > 0) {
    // 从withdrawAmount倒数到目标值
    animateNumber2(withdrawAmount.value, newValue, 4000);
  }
});

const rawList = ref([
  { id: '11912345678', action: t('turntable.justWithdrew'), amount: '100' },
  { id: '21987654321', action: t('turntable.justWithdrew'), amount: '100' },
  { id: '31991234567', action: t('turntable.justWithdrew'), amount: '100' },
  { id: '41998765432', action: t('turntable.justWithdrew'), amount: '100' },
  { id: '61912349876', action: t('turntable.justWithdrew'), amount: '100' },
  { id: '71979876543', action: t('turntable.justWithdrew'), amount: '100' },
  { id: '81991237654', action: t('turntable.justWithdrew'), amount: '100' },
  { id: '91983451234', action: t('turntable.justWithdrew'), amount: '100' },
  { id: '51920345678', action: t('turntable.justWithdrew'), amount: '100' },
  { id: '62931234567', action: t('turntable.justWithdrew'), amount: '100' },
  { id: '71912346789', action: t('turntable.justWithdrew'), amount: '100' },
  { id: '85929876543', action: t('turntable.justWithdrew'), amount: '100' },
  { id: '22939877654', action: t('turntable.justWithdrew'), amount: '100' },
  { id: '62931239876', action: t('turntable.justWithdrew'), amount: '100' },
  { id: '19967543210', action: t('turntable.justWithdrew'), amount: '100' },
  { id: '77977654321', action: t('turntable.justWithdrew'), amount: '100' },
  { id: '35961238765', action: t('turntable.justWithdrew'), amount: '100' },
  { id: '34924567890', action: t('turntable.justWithdrew'), amount: '100' },
  { id: '48912345432', action: t('turntable.justWithdrew'), amount: '100' },
  { id: '43999876543', action: t('turntable.justWithdrew'), amount: '100' },
  { id: '11987654321', action: t('turntable.justWithdrew'), amount: '100' },
  { id: '21982345678', action: t('turntable.justWithdrew'), amount: '100' },
  { id: '31987654321', action: t('turntable.justWithdrew'), amount: '100' },
  { id: '41991234567', action: t('turntable.justWithdrew'), amount: '100' },
  { id: '61987654321', action: t('turntable.justWithdrew'), amount: '100' },
  { id: '71912345678', action: t('turntable.justWithdrew'), amount: '100' },
  { id: '81923456789', action: t('turntable.justWithdrew'), amount: '100' },
  { id: '91912345678', action: t('turntable.justWithdrew'), amount: '100' },
  { id: '51987654321', action: t('turntable.justWithdrew'), amount: '100' },
  { id: '62998765432', action: t('turntable.justWithdrew'), amount: '100' },
  { id: '71987654321', action: t('turntable.justWithdrew'), amount: '100' },
  { id: '82912345678', action: t('turntable.justWithdrew'), amount: '100' },
  { id: '22991234567', action: t('turntable.justWithdrew'), amount: '100' },
  { id: '62987654321', action: t('turntable.justWithdrew'), amount: '100' },
  { id: '19987654321', action: t('turntable.justWithdrew'), amount: '100' },
  { id: '77912345678', action: t('turntable.justWithdrew'), amount: '100' },
  { id: '35998765432', action: t('turntable.justWithdrew'), amount: '100' },
  { id: '34987654321', action: t('turntable.justWithdrew'), amount: '100' },
  { id: '48912347654', action: t('turntable.justWithdrew'), amount: '100' },
  { id: '43987654321', action: t('turntable.justWithdrew'), amount: '100' }
]); // 抽奖记录 - 使用你提供的手机号码作为ID

const referenciaRawList = ref([]); // 提现记录 - 从接口获取

// 脱敏函数 - 修改为处理可能为 null 的 userId
const maskId = (id: string | number | null) => {
  if (!id) return 'Unknown';
  const idStr = id.toString();
  if (idStr.length <= 4) return idStr;
  return idStr.slice(0, 2) + '*'.repeat(idStr.length - 4) + idStr.slice(-2);
}

// 滚动相关
const displayList = ref([...rawList.value, ...rawList.value]) // 复制一份用于无缝滚动
const referenciaDisplayList = ref([...referenciaRawList.value]) // 不需要复制，直接使用原数据
const scrollOffset = ref(0)
const referenciaScrollOffset = ref(0)
const itemHeight = 32 // 每条高度，需和样式一致
let scrollTimer: number | null = null

const startScroll = () => {
  scrollTimer = window.setInterval(() => {
    // 只有 relatorio 标签页需要自动滚动
    if (activeTab.value === 'relatorio') {
      scrollOffset.value -= 1

      // 当滚动到第一份数据的末尾时，无缝跳转到第二份数据的开始
      if (Math.abs(scrollOffset.value) >= rawList.value.length * itemHeight) {
        scrollOffset.value = 0
      }
    }
    // Minha Referencia 标签页不需要自动滚动
  }, 30)
}


// 组件卸载时清理定时器
onUnmounted(() => {
  if (scrollTimer) {
    clearInterval(scrollTimer)
    scrollTimer = null
  }
  if (countDownTimer) {
    clearInterval(countDownTimer);
    countDownTimer = null;
  }
})

const activeTab = ref('relatorio')

// 分享弹窗相关
const showSharePopup = ref(false);
const selectedUser = ref(null);

// 随机用户数据 - 从接口获取
const randomUsers = ref([]);

// 复制链接
const copyLink = async () => {
  try {
    await navigator.clipboard.writeText(shareLink.value);
    (window as any).$toast(t('turntable.copySuccess'));

  } catch (err) {

  }
};

// 选择用户
const selectUser = (user) => {
  selectedUser.value = user;
  window.$toast(` ${user.phone}`);
};

// 添加一个监听器来监听弹窗显示状态
watch(showSharePopup, (newValue) => {
  if (newValue) {
    // 弹窗显示后，等待 DOM 渲染完成再初始化 ShareThis
    nextTick(() => {
      initShareThis()
    })
  }
})

// 将 ShareThis 初始化函数提取出来
const initShareThis = () => {
  // 确保 DOM 元素存在
  const container = document.getElementById('my-inline-buttons')
  if (!container) {
    console.warn('ShareThis container not found')
    return
  }

  if (window.__sharethis__) {
    try {
      window.__sharethis__.load('inline-share-buttons', {
        alignment: 'justified',
        id: 'my-inline-buttons',
        enabled: true,
        font_size: 12,
        padding: 10,
        radius: 0,
        networks: ['facebook', 'twitter', 'whatsapp', 'telegram'],
        size: 40,
        show_mobile_buttons: true,
        spacing: 8,
        url: shareContent.url,
        title: shareContent.title,
        language: 'en',
        image: '',
        description: shareContent.description,
        username: ''
      })
    } catch (error) {
      console.error('ShareThis initialization failed:', error)
    }
  } else {
    // 如果 ShareThis 还没加载，等待后重试
    setTimeout(initShareThis, 200)
  }
}

// SAQUE弹窗相关
const showSaquePopup = ref(false);

// 处理邀请按钮点击
const handleInviteClick = () => {
  showSaquePopup.value = false;
  showSharePopup.value = true;
};

// 添加登录弹窗相关变量
const showAuthDialog = ref(false);
const authIsLogin = ref(true);

// 添加新的响应式变量
const showPrizeAmount = ref(false); // 控制是否显示中奖金额
const currentPrizeAmount = ref(''); // 当前中奖金额

// 修改标签页点击事件
const handleTabClick = (tab: string) => {
  if (tab === 'referencia') {
    // 检查是否已登录
    if (!userStore.userInfo || !userStore.userInfo.userId) {
      // 未登录，显示登录弹窗
      showAuthDialog.value = true;
      authIsLogin.value = true;
      return;
    }
  }

  // 已登录或点击其他标签页，正常切换
  activeTab.value = tab;
};

// 处理登录弹窗关闭
const handleAuthDialogClose = () => {
  showAuthDialog.value = false;

  // 检查是否登录成功
  if (userStore.userInfo && userStore.userInfo.userId) {
    // 登录成功，重新获取数据
    fetchData();
  }
};

// 处理登录弹窗切换
const handleAuthDialogSwitch = (isLogin: boolean) => {
  authIsLogin.value = isLogin;
};

// 添加SAQUE弹窗关闭处理函数
const handleSaquePopupClose = () => {
  // 关闭弹窗时恢复显示次数
  showPrizeAmount.value = false;
  currentPrizeAmount.value = '';
};

// 监听用户登录状态变化
watch(() => userStore.userInfo?.userId, (newUserId, oldUserId) => {
  // 如果用户ID发生变化（包括登出或切换用户）
  if (oldUserId !== newUserId) {
    console.log('用户切换，清除转盘缓存并重置数据', { oldUserId, newUserId });
    // 清除旧用户的缓存
    clearTurntableCache();
    // 重置所有数据
    resetTurntableData();
    // 如果是新用户登录，重新获取数据
    if (newUserId) {
      fetchData();
    }
  }
});

onMounted(() => {
  console.log('转盘页面挂载，开始获取数据...');
  // 组件挂载后获取数据
  fetchData();
  startScroll();
});

// 根据屏幕宽度计算圆角
const getBorderRadius = () => {
  const width = window.innerWidth;
  if (width <= 360) {
    return '15px';
  } else if (width <= 480) {
    return '20px';
  } else {
    return '35px';
  }
};
</script>
<style lang="scss" scoped>
.headerTitleBoxContainer {
  background: getPath("activity/dazhuanpan/contentTitleBg.png") no-repeat;
  background-size: 100% 100%;

  .headerTitleBox {
    background: getPath("activity/dazhuanpan/stripe.png") no-repeat;
    background-size: 100% 100%;
  }
}

/* 吸顶导航栏样式 */
.sticky-nav {
  position: fixed !important;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
}

/* 内容区域，为吸顶导航栏留出空间 */
.content-container {
  margin-top: 56px;
  /* 导航栏高度 */
  padding-top: 1px;
  background: getPath("activity/dazhuanpan/bg.png") no-repeat;
  background-size: 100% 100%;

}

.custom-nav-bar {
  height: 56px;
  box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.3), 0px -2px 22px 0px rgba(53, 189, 128, 0.61);

  &>* {
    height: 100%;
  }
}

.dwjers {
  margin-top: -95px;
}

/* 移动端负边距 */
@media (max-width: 600px) {
  .dwjers {
    margin-top: -95px;
  }
}

.dogtitle {
  font-size: 13px;
  font-weight: bold;
  color: #898988;
}

@media (max-width:500px) {
  .dogtitle {
    font-size: 14px;
  }
}

.saquestyle {
  width: 79px;
  height: 20px;
  background: getPath("activity/dazhuanpan/withdrawBg.png") no-repeat;
  background-size: 100% 100%;
  // border-radius: 10px;
  display: flex;
  align-items: center;
  color: #FFFFFF;
  font-size: 12px;
  // padding: 0 6px;
  text-align: center;
  font-weight: bold;
  line-height: 24px;
}

.prossess {
  background: #290452;
  border-radius: 6px;
  height: 11px;
  margin-top: 3px;
  position: relative;

  &::before {
    position: absolute;
    top: 0;
    left: 1px;
    content: '';
    display: block;
    width: calc(100% - 2px);
    height: 30%;
    background: linear-gradient(0deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0.3) 25%, rgba(255, 255, 255, 0.2) 50%, rgba(255, 255, 255, 0) 100%);
    border-radius: 100vh 100vh 0 0;
  }
}

.prossess-item {
  width: 23px;
  height: 23px;
  background: getPath("activity/dazhuanpan/prossessIcon.png") no-repeat;
  background-size: 100% 100%;
  transform: translate(0, -25%);
  transition: transform 0.1s ease;
}

.prossess-in {
  position: relative;
  box-shadow:
    /* 上内 */
    inset -2px 0px 2px 2px #00dbf3,
    /* 右内 */
    inset 0px 0 0px 0px #00dbf3,
    /* 下内 */
    inset 0px -3px 2px 0px #00dbf3,
    /* 左内 */
    inset 0px -2px 2px 0px #00dbf3;

  transition: left 0.1s ease;
}

/* 灯光突然切换闪烁效果 */
.light-switch {
  animation: lightSwitch 4s steps(2) infinite;
  /* 4秒循环，分2步 */
  filter: drop-shadow(0 0 15px rgba(255, 255, 0, 0.6));
  transform-origin: center center;
}

/* 灯光突然切换关键帧动画 */
@keyframes lightSwitch {
  0% {
    transform: translate(-50%, -50%) rotate(0deg);
  }

  50% {
    transform: translate(-50%, -50%) rotate(45deg);
    /* 突然旋转45度，更微妙 */
  }

  100% {
    transform: translate(-50%, -50%) rotate(90deg);
    /* 再突然旋转45度 */
  }
}

/* 旋转动画 - 底层光圈保持自动缓慢旋转 */
.rotating-image {
  animation: rotate 30s linear infinite;
  /* 保持自动缓慢旋转 */
  filter: none !important;
  box-shadow: none !important;
  -webkit-filter: none !important;
  -webkit-box-shadow: none !important;
  text-shadow: none !important;

  transition: transform 0.1s ease;
}

/* 移除spinning类对光圈的控制 */
/* .rotating-image.spinning {
    animation: rotate 4s linear infinite;
} */

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

/* 转盘容器旋转动画 - 使用transform而不是animation，实现缓慢停止 */
.turntable-container {
  filter: none !important;
  box-shadow: none !important;
  -webkit-filter: none !important;
  -webkit-box-shadow: none !important;
  text-shadow: none !important;
  transform: rotate(v-bind(spinAngle + 'deg'));
  transition: transform 0.1s ease;
}

/* 移除spinning类的animation，改用transform控制 */
/* .turntable-container.spinning {
    animation: rotate 1s linear infinite;
} */

/* 中奖区域的闪光效果 */
@keyframes winnerFlash {

  0%,
  100% {
    box-shadow: 0 0 0 0 rgba(177, 74, 74, 0);
    border: 2px solid transparent;
  }

  50% {
    box-shadow: 0 0 20px 10px rgba(255, 255, 255, 0.8);
    border: 2px solid rgba(255, 255, 255, 0.9);
  }
}

.winner-flash {
  animation: winnerFlash 0.6s ease-in-out infinite;
  border-radius: 2% 20% 0 0;
  /* 改成扇形 */
  z-index: 50;
}

/* 奖品容器样式调整 */
.turntable-prize {
  position: absolute;
  width: 38px;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  /* 以转盘中心为原点进行定位 */
  top: 50%;
  left: 50%;
  transform-origin: 0 0;
  border-radius: 50%;
  transition: all 0.3s ease;
}

/* 使用极坐标方式定位每个奖品到扇形中心 - 指针在12点钟方向 */
.prize-0 {
  /* 12点钟方向 (0度) - 顶部 - 图片 */
  transform: translate(-50%, -80%) rotate(0deg) translateY(-80px) rotate(0deg);
}

.prize-1 {
  /* 1点半方向 (45度) - 右上 - 图片 */
  transform: translate(-20%, -55%) rotate(45deg) translateY(-102px) rotate(-0deg);
}

.prize-2 {
  /* 3点钟方向 (90度) - 右侧 - 图片 */
  transform: translate(-40%, -55%) rotate(90deg) translateY(-125px) rotate(0deg);
}

.prize-3 {
  /* 4点半方向 (135度) - 右下 - 图片 */
  transform: translate(-65%, -10%) rotate(120deg) translateY(-134px) rotate(12deg);
}

.prize-4 {
  /* 6点钟方向 (180度) - 底部 - 图片 */
  transform: translate(50%, 80%) rotate(180deg) translateY(-80px) rotate(-360deg);
}

.prize-5 {
  /* 7点半方向 (225度) - 左下 - 图片 */
  transform: translate(-60%, -30%) rotate(225deg) translateY(-92px) rotate(-225deg);
}

.prize-5 .prize-image {
  width: 35px;
  /* prize-2 保持默认大小 */
  height: 35px;
}

.prize-6 {
  /* 9点钟方向 (270度) - 左侧 - 图片 */
  transform: translate(-40%, 75%) rotate(275deg) translateY(-94px) rotate(-367deg);
}

.prize-7 {
  /* 10点半方向 (315度) - 左上 - 图片 */
  transform: translate(-48%, -119%) rotate(300deg) translateY(-75px) rotate(55deg);
}

.prize-money {
  font-size: 20px;
  /* 从14px改为12px */
  font-weight: bold;
  text-align: center;
}

/* 为每个奖品位置设置不同的颜色 */
.money-color-1 {
  color: #F7DC69;
  /* 1,00 - 金色 */
}

.money-color-2 {
  color: #B90615;
  /* 50,00 - 红色 */
}

.money-color-3 {
  color: #F7DC69;
  /* 30,00 - 金色 */
}

.money-color-6 {
  color: #B90615;
  /* 100,00 - 红色 */
}

.prize-image {
  width: 50px;
  /* 从28px改为22px */
  height: 50px;
  /* 从28px改为22px */
  object-fit: contain;
}

.bojksee {
  width: 90%;
  margin-left: 15px;
  height: 32px;
  line-height: 26px;
  background: getPath("activity/dazhuanpan/shareTitleBg.png") no-repeat;
  background-size: 100% 100%;
  border-radius: 4px;
  font-size: 13px;



}

.teabser {
  width: 90%;
  margin-left: 15px;
  background: getPath("activity/dazhuanpan/teabserBg.png") no-repeat;
  background-size: 100% 100%;
  height: 30px;
  margin-top: 20px;
  line-height: 36px;
  font-size: 13px;

  display: flex;
  justify-content: space-around;
}

.tabdatastyle {
  width: 90%;
  margin-left: 15px;
  padding-left: 10px;
  background: #005D52;
  height: 150px;
  padding-top: 15px;
  border-radius: 0 0 6px 6px;
  font-size: 12px;
  color: #5BAB83;
  overflow: hidden;
  position: relative;
}

.scroll-container {
  height: 140px;
  /* 显示区域高度，可根据需要调整 */
  overflow: hidden;
  position: relative;
}

/* 新增：Minha Referencia 手动滚动 */
.manual-scroll {
  overflow-y: auto !important;
  height: 120px;
}

/* 自定义滚动条样式 */
.manual-scroll::-webkit-scrollbar {
  width: 4px;
  /* 滚动条宽度 */
}

.manual-scroll::-webkit-scrollbar-track {
  background: #18553A;
  /* 滚动条轨道背景色，和父盒子一致 */
  border-radius: 2px;
}

.manual-scroll::-webkit-scrollbar-thumb {
  background: #5BAB83;
  /* 滚动条滑块颜色，和文字颜色一致 */
  border-radius: 2px;
}

.manual-scroll::-webkit-scrollbar-thumb:hover {
  background: #7BDE42;
  /* 鼠标悬停时的颜色 */
}

/* Firefox 滚动条样式 */
.manual-scroll {
  scrollbar-width: thin;
  scrollbar-color: #5BAB83 #18553A;
}

.scroll-content {
  /* 移除transition，避免卡顿 */
  will-change: transform;
}

.active-tab {
  color: #F1EA4A !important;
  /* border-radius: 6px 6px; */
  font-weight: bold;
  /* 你可以根据实际需求调整padding和高度 */
}

.teabser>div {
  flex: 1;
  text-align: center;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
  border-radius: 6px 6px 0 0;
  color: #fff;
  /* 默认白色 */
  font-weight: normal;
}

.textstyles {
  background: #005D52;
  width: 90%;
  margin-top: 20px;
  margin-left: 15px;
  font-size: 13px;
  border-radius: 5px;
  padding: 10px;
  color: #18C2B3;
}

/* SAQUE弹窗样式 */
.saque-popup-content {
  padding: 20px;
  color: #fff;
}

.saque-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 15px;
  color: #fff;
}

.balance-section {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  margin-top: 10px;
}

.balance-label {
  font-size: 12px;
  color: #7BDE42;
  /* 改为浅绿色 */
}

.balance-amount {
  display: flex;
  align-items: baseline;
  gap: 2px;
}

.balance-value {
  font-size: 25px;
  font-weight: bold;
  color: #EE4639;
}

.balance-currency {
  font-size: 25px;
  font-weight: bold;
  margin-top: 5px;
  color: #EE4639;
}

.initiation-section {
  margin-left: 10px;
}

.initiation-label {

  font-size: 12px;
  color: #fff;
  margin-bottom: 8px;
}

.initiation-value {
  height: 20px;
}

.payment-section {}

.payment-label {
  font-size: 12px;
  color: #fff;
  margin-left: 10px;
  margin-bottom: 15px;
}

.payment-steps {
  background: #006849;
  border-radius: 8px;
  padding: 10px 15px;
  margin: 10px;
}

.step-item {
  display: flex;
  align-items: center;
  margin-bottom: 23px;
  position: relative;
}

.step-item:last-child {
  margin-bottom: 0;
}

.step-icon {
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-right: 10px;
  border-radius: 50%;
  background: #7BDE42;
  /* 绿色背景 */
}

.step-dotder {
  width: 10px;
  height: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-left: 2px;
  border-radius: 50%;
  background: #fff;
  /* 绿色背景 */
}

/* .step-item:last-child .step-icon {
    background: #fff;
} */

.step-text {
  font-size: 10px;
  color: #7BDE42;
  line-height: 1.4;
  flex: 1;
  height: 10px;
  margin-left: 5px;
}

.step-item:last-child .step-text {
  color: #fff;
}

.step-dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #fff;
}

/* 调整连接线位置 */
/* 第一个连接线 */
.step-item:first-child::after {
  content: '';
  position: absolute;
  left: 6px;
  top: 18px;
  width: 1px;
  height: 18px;
  background: #629093;
}

/* 第二个连接线 */
.step-item:nth-child(2)::after {
  content: '';
  position: absolute;
  left: 6px;
  top: 18px;
  /* 调整第二个连接线的起始位置 */
  width: 1px;
  height: 18px;
  background: #629093;
}

/* 小屏手机 */
@media (max-width: 480px) {
  .step-item:nth-child(2)::after {
    content: '';
    position: absolute;
    left: 7px;
    top: 24px;
    /* 调整第二个连接线的起始位置 */
    width: 1px;
    height: 18px;
    background: #629093;
  }
}

/* 中等手机屏幕 */
@media (max-width: 568px) {
  .step-item:nth-child(2)::after {
    content: '';
    position: absolute;
    left: 7px;
    top: 26px;
    /* 调整第二个连接线的起始位置 */
    width: 1px;
    height: 13px;
    background: #629093;
  }
}

/* 大屏手机 */
@media (max-width: 768px) {
  .step-item:nth-child(2)::after {
    content: '';
    position: absolute;
    left: 7px;
    top: 26px;
    /* 调整第二个连接线的起始位置 */
    width: 1px;
    height: 18px;
    background: #629093;
  }
}

.button-section {
  display: flex;
  justify-content: center;
}

.invite-button {
  position: relative;
  width: 85%;
  height: 34px;
  background: #7BDE42;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 12px;
  font-weight: bold;
  margin-top: 20px;
  cursor: pointer;
  overflow: hidden;
}

/* 按钮镜片滑动动画 */
.button-shine {
  position: absolute;
  top: -50%;
  left: -100%;
  width: 100%;
  height: 200%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.8), transparent);
  transform: rotate(45deg);
  animation: shine 3s infinite;
  z-index: 1;
}

@keyframes shine {
  0% {
    left: -100%;
    opacity: 0;
  }

  5% {
    opacity: 1;
  }

  25% {
    left: 100%;
    opacity: 1;
  }

  30% {
    left: 100%;
    opacity: 0;
  }

  100% {
    left: 100%;
    opacity: 0;
  }
}

/* 响应式调整 */
@media (max-width: 500px) {
  .saque-popup-content {
    padding: 15px;
  }

  .balance-value {
    font-size: 20px;
  }

  .balance-currency {
    font-size: 14px;
  }
}

.step-text.text-green {
  color: #7BDE42 !important;
}

/* 确保成功图标样式正确 */
.step-icon .van-icon {
  color: #fff !important;
  background: #7BDE42 !important;
}

/* 确保白色圆点样式正确 */
.step-dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #fff !important;
}

/* 在 style 标签中添加媒体查询 */
@media (max-width: 480px) {
  .saque-popup {
    border-radius: 20px !important;
  }
}

@media (max-width: 360px) {
  .saque-popup {
    border-radius: 15px !important;
  }
}
</style>
